<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M8.00084 15.4284C12.1035 15.4284 15.4294 12.1025 15.4294 7.99986C15.4294 3.89717 12.1035 0.571289 8.00084 0.571289C3.89815 0.571289 0.572266 3.89717 0.572266 7.99986C0.572266 12.1025 3.89815 15.4284 8.00084 15.4284Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.89062 8.75889C3.21787 8.60049 4.02693 8.40275 4.64522 8.879C5.26349 9.35525 5.27881 10.188 5.20919 10.5448C5.13955 10.9017 5.15486 11.7344 5.77315 12.2106C6.39142 12.687 7.20049 12.4891 7.52773 12.3307"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.0966 7.42867C11.1486 7.42867 12.0014 6.57587 12.0014 5.52391C12.0014 4.47193 11.1486 3.61914 10.0966 3.61914C9.32892 3.61914 8.66728 4.07333 8.36577 4.72767C8.17077 4.62784 7.94981 4.57153 7.71568 4.57153C6.9267 4.57153 6.28711 5.21112 6.28711 6.0001C6.28711 6.78907 6.9267 7.42867 7.71568 7.42867C8.15232 7.42867 8.54321 7.23278 8.80525 6.92408C9.1447 7.23731 9.59832 7.42867 10.0966 7.42867Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.43028 10.2859C9.27246 10.2859 9.14453 10.1579 9.14453 10.0001C9.14453 9.84229 9.27246 9.71436 9.43028 9.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.42969 10.2859C9.5875 10.2859 9.71544 10.1579 9.71544 10.0001C9.71544 9.84229 9.5875 9.71436 9.42969 9.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.71544 6.28585C3.55762 6.28585 3.42969 6.15792 3.42969 6.0001C3.42969 5.84229 3.55762 5.71436 3.71544 5.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.71484 6.28585C3.87266 6.28585 4.00059 6.15792 4.00059 6.0001C4.00059 5.84229 3.87266 5.71436 3.71484 5.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.7154 11.4285C11.5576 11.4285 11.4297 11.3005 11.4297 11.1427C11.4297 10.9849 11.5576 10.8569 11.7154 10.8569"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.7148 11.4285C11.8727 11.4285 12.0006 11.3005 12.0006 11.1427C12.0006 10.9849 11.8727 10.8569 11.7148 10.8569"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
